<div randomSymbolColor class="symbol mr-3">
  <span
    class="symbol-label font-weight-bold"
    [ngClass]="isBigSymbol == true ? 'font-size-h1' : 'font-size-h5'"
    randomSymbolColor
    >{{ formattedLabel }}</span
  >
</div>
